export default __webpack_public_path__ + "static/media/Wallet.f9d268d7.png";